import { Button, Label, toast } from "@veritrellis/ui";

export const CopyableId = (input: {
  id: string;
  label?: string;
  helper?: string;
  buttonLabel?: string;
}) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(input.id);
      toast.show({
        title: "Copied",
        message: "Value copied to clipboard.",
        color: "green"
      });
    } catch {
      toast.show({
        title: "Copy failed",
        message: "Clipboard was not available.",
        color: "red"
      });
    }
  };

  return (
    <div>
      {input.label !== undefined ? <Label className="mb-1 block">{input.label}</Label> : null}
      {input.helper !== undefined ? (
        <p className="mb-2 text-sm text-muted-foreground">{input.helper}</p>
      ) : null}
      <div className="flex flex-nowrap items-start gap-2">
        <pre className="min-w-0 flex-1 break-all rounded-md border bg-muted px-3 py-2 font-mono text-sm">
          {input.id}
        </pre>
        <Button variant="secondary" size="sm" onClick={() => void copy()}>
          {input.buttonLabel ?? "Copy"}
        </Button>
      </div>
    </div>
  );
};
